var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-action-card"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"action-name"},[_vm._v("行为类型："+_vm._s(_vm.behaviorItem.item_type_desc))])]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.behaviorItem.detail)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }